export default __webpack_public_path__ + "static/confetti-0db77201bc13fb1ad3315bf9f3d36868.svg";